import type { FunctionComponent } from "react";
import styled from "styled-components";
import { setFont } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import type { IListItem } from "./DomainListWithTooltip/types";

const { carbon } = colorsPalettes;

interface IHorizontalColoredListItemsCellProps {
    value: IListItem[];
}

const Container = styled.div`
    display: flex;
    column-gap: 9px;
`;

const Dot = styled.div<{ color: string }>`
    align-self: center;
    height: 10px;
    width: 10px;
    border-radius: 8px;
    ${({ color }) => `background-color:${color}`}
`;

const Text = styled.span`
    align-self: center;
    ${setFont({ $size: 14, $weight: 400 })};
`;

const ListItemContainer = styled.div<{ setOpacity?: boolean }>`
    display: flex;
    column-gap: 5px;
    opacity: ${({ setOpacity }) => (setOpacity ? 0.4 : 1)};
`;

const renderListItem = (listItem: IListItem) => {
    const { color, displayText, isAutoSuggest } = listItem;
    return (
        <ListItemContainer
            key={displayText}
            setOpacity={isAutoSuggest}
        >
            <Dot color={color} />
            <Text>{displayText}</Text>
        </ListItemContainer>
    );
};

export const HorizontalColoredListItemsCell: FunctionComponent<IHorizontalColoredListItemsCellProps> = (props) => {
    const { value: listItems } = props;
    return <Container>{listItems.map(renderListItem)}</Container>;
};
